import { render, staticRenderFns } from "./EditarClienteProveedorModal.vue?vue&type=template&id=b220e84e&"
import script from "./EditarClienteProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./EditarClienteProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports